import React, { MutableRefObject } from "react";
import ct from "class-types.macro";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import Button from "~/common/Buttons";
import Icon from "~/common/Icons/Standard";
import { OutletAttributes } from "~/common/Store/models/ProductListing";
import { AddToCartModal } from ".";

interface Props extends AddToCartModal<"outlet"> {
  outletAttributes: OutletAttributes;
  hasAcknowledgedOutletItem: MutableRefObject<boolean>;
}

export default ({
  isOpen,
  closeModal,
  submitModal,
  outletAttributes,
  hasAcknowledgedOutletItem,
}: Props) => {
  const handleAddToCart = async (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (hasAcknowledgedOutletItem) {
      // eslint-disable-next-line no-param-reassign
      hasAcknowledgedOutletItem.current = true;
    }

    submitModal();
  };

  const iconProps = { className: "svg fill-current text-gray-400 h-5 w-5" };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="w-11/12 md:max-w-md"
    >
      <Header closeModal={closeModal}>
        <Icon {...iconProps} name="attention" />
        <h3 className="flex m-0 ml-3 text-base md:text-xl">
          This is an Outlet Item
        </h3>
      </Header>
      <Body>
        <h4 className={`${ct("font-bold")}`}>PRODUCT CONDITION DETAILS</h4>
        <div
          className={`${ct("text-sm")}`}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: outletAttributes.outletHighlights,
          }}
        />
      </Body>
      <Footer>
        <Button
          color="light"
          aria-label="Cancel"
          type="button"
          onClick={closeModal}
        >
          No, Thank You
        </Button>
        <Button
          className="ml-3"
          color="red"
          aria-label="Submit Feedback"
          type="submit"
          onClick={handleAddToCart}
        >
          Yes, Add to My Cart
        </Button>
      </Footer>
    </Modal>
  );
};
